<script>
  import {
    datagridStore,
    datagridFilterStore,
  } from "../../../stores/datagrid.store";

  import get from "get-value";
  import { onDestroy } from "svelte";

  import { paginate } from "./datagrid.func";

  let data = [];
  let pages = 0;
  let unsubscribeDatagridStore = datagridStore.subscribe((store) => {
    data = get(store) || {};
    if (data.data) {
      if (get(data, "search")) {
        pages = Math.ceil(data.recordsFiltered / data.pagination.limit);
      } else {
        pages = Math.ceil(
          get(data, "recordsTotal.count", 0) / data.pagination.limit
        );
      }
    }
  });

  onDestroy(unsubscribeDatagridStore);

  let filter = {};
  let unsubscribeDatagridFilterStore = datagridFilterStore.subscribe(
    (store) => {
      filter = get(store) || {};
    }
  );

  onDestroy(unsubscribeDatagridFilterStore);
</script>

{#if pages > 1}
  <div class="pagination">
    <ul class="pagination__list">
      {#each Array(pages) as _, page}
        {@const start =
          parseInt(filter.post.pagination.start) > 0
            ? (parseInt(filter.post.pagination.start) - 1) /
              data.pagination.limit
            : 0}
        <li
          on:click={() =>
            paginate(page > 0 ? page * data.pagination.limit + 1 : 0)}
        >
          <span class={start === page ? "active" : ""}>{page + 1}</span>
        </li>
      {/each}
    </ul>
  </div>
{/if}

<style lang="scss">
  .pagination__list li {
    cursor: pointer;
  }
</style>
